<div class="note">

  <!-- type icon -->
  <div class="note__icon" [ngClass]="'type-' + ((touch.customNoteTypeName || '') + '').toLowerCase().replace(' ', '-')">
    <mat-icon>{{ noteIcon(touch.customNoteTypeName) }}</mat-icon>
  </div>

  <div class="note__body">

    <div class="note__title">
      <h4>{{ touch.customNoteTypeName }}</h4>
      <span class="note__chip" *ngIf="touch.customNoteStatusName">{{ touch.customNoteStatusName }}</span>
    </div>

    <div class="note__text touch-note">
      <p [innerHTML]="touch.customNoteNew"></p>
    </div>

    <div class="note__meta">
      <span class="note__avatar">{{ initials(touch.createdByFirstName, touch.createdByLastName) }}</span>
      <span class="note__author">{{ touch.createdByFirstName | titlecase }} {{ touch.createdByLastName | titlecase }}</span>
      <span class="note__dot">•</span>
      <span class="note__date">{{ touch.createdOn + 'Z' | date:'MM/dd/yyyy' }}</span>
    </div>

  </div>

  <div class="note__actions">
    <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="More">
      <mat-icon>more_horiz</mat-icon>
    </button>
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item (click)="editCustomInfo(touch)"><mat-icon>edit</mat-icon> Edit</button>
      <button mat-menu-item (click)="deleteCustomInfo(touch)"><mat-icon>delete_outline</mat-icon> Delete</button>
    </mat-menu>
  </div>

</div>
